// extracted by mini-css-extract-plugin
export var ourRatingBackground = "companyRatings-module--ourRatingBackground--KrxPC";
export var ourRatingBackgroundVisible = "companyRatings-module--ourRatingBackgroundVisible--cvCNa";
export var yourRatingBackground = "companyRatings-module--yourRatingBackground--cD5bo";
export var yourRatingBackgroundVisible = "companyRatings-module--yourRatingBackgroundVisible--Nym1S";